import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Star, Clock, ArrowRight } from 'lucide-react';
import { formatINR } from '../lib/whatsapp';
import { fadeUp } from '../theme/theme';
import { useSettings } from '../context/SettingsContext';

export default function PackageCard({ pkg }) {
  const { showPricing } = useSettings();
  return (
    <motion.div
      variants={fadeUp}
      whileHover={{ y: -8 }}
      transition={{ type: 'spring', stiffness: 260, damping: 22 }}
      className="group glass overflow-hidden"
    >
      <div className="relative h-52 overflow-hidden">
        <img
          src={pkg.cover}
          alt={pkg.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/20 to-transparent" />
        {pkg.tag && (
          <span className="absolute left-4 top-4 rounded-pill bg-brand-gradient px-3 py-1 text-xs font-semibold text-white shadow-brand-glow">
            {pkg.tag}
          </span>
        )}
        <span className="absolute right-4 top-4 flex items-center gap-1 rounded-pill bg-black/40 px-2.5 py-1 text-xs font-medium text-white backdrop-blur">
          <Star size={13} className="fill-warning text-warning" />
          {pkg.rating}
        </span>
      </div>

      <div className="space-y-3 p-5">
        <div className="flex items-center justify-between text-xs text-ink-300">
          <span className="rounded-pill bg-white/5 px-2.5 py-1">{pkg.category}</span>
          <span className="flex items-center gap-1"><Clock size={13} /> {pkg.duration}</span>
        </div>
        <h3 className="font-display text-lg font-bold text-white">{pkg.title}</h3>
        <p className="line-clamp-2 text-sm text-ink-300">{pkg.summary}</p>
        <div className="flex items-center justify-between pt-2">
          <div>
            {showPricing ? (
              <>
                <p className="text-xs text-ink-400">Starting from</p>
                <p className="font-display text-xl font-bold text-gradient">
                  {formatINR(pkg.price)}
                </p>
              </>
            ) : (
              <p className="font-display text-sm font-semibold text-ink-200">Price on request</p>
            )}
          </div>
          <Link
            to={`/packages/${pkg.id}`}
            className="flex items-center gap-1 rounded-pill border border-white/15 px-4 py-2 text-sm font-medium text-white transition hover:border-white/40 hover:bg-white/5"
          >
            View <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </motion.div>
  );
}
